import Request from './request';
import qs from 'qs';
export const signFlowInitApi = (data) => Request.post('/api/sign/flow/init', qs.stringify(data), { 'Content-Type': 'application/x-www-form-urlencoded' }); // 签署流程初始化

export const signCheckStatusApi = (params) => Request.get('/api/sign/checkStatus', params); // 检查当前用户的身份核验状态

export const signVerificationUserInfoApi = () => Request.get('/api/sign/verification/userInfo'); // 身份核验
export const signVerificationSendCodeApi = (data) => Request.post('/api/sign/verification/sendCode', data); // 发送验证码

export const signVerifyPersonalApi = (data) => Request.post('/api/sign/verifyPersonal', data); // 个人身份核验

export const signAgreementViewApi = (data) => Request.post('/api/sign/agreement/view', data); // 查看协议

export const signAgreementAgreeApi = (data) => Request.post('/api/sign/agreement/agree', data); // 同意协议

export const signPasswordStatusApi = (params) => Request.get('/api/sign/password/status', params); // 查询密码状态

export const signPasswordVerifyApi = (data) => Request.post('/api/sign/password/verify', data); // 验证密码

export const signPasswordSendCodeApi = (data) => Request.post('/api/sign/password/sendCode', data); // 发送验证码

export const signPasswordSetApi = (data) => Request.post('/api/sign/password/set', data); // 设置密码

export const signCertificateApplyApi = (data) => Request.post('/api/sign/certificate/apply', data); // 申请证书

export const signVerifyOperatorApi = (data) => Request.post('/api/sign/verifyOperator', data); // 经办人核验（手机三要素）

export const signAuthorizationViewApi = (params) => Request.get('/api/sign/authorization/view', params); // 预览授权书 PDF

export const signAuthorizationConfirmApi = (data) => Request.post('/api/sign/authorization/confirm', data); // 确认授权书（含工商三要素验证）

export const signAuthorizationSendCodeApi = (data) => Request.post('/api/sign/authorization/sendCode', data); // 发送授权书确认短信验证码

// /api/sign/log/userBehavior post
export const signLogUserBehaviorApi = (data) => Request.post('/api/sign/log/userBehavior', qs.stringify(data), { 'Content-Type': 'application/x-www-form-urlencoded' }); // 用户行为日志

export const signVerifyBusinessApi = (data) => Request.post('/api/sign/verifyBusiness', data); // 企业信息核验（工商三要素验证）


// WEBPACK FOOTER //
// ./src/api/common.js